module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/lang/fr.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/components/accordion-group/accordion-group.lang.fr.json":
/*!*********************************************************************!*\
  !*** ./src/components/accordion-group/accordion-group.lang.fr.json ***!
  \*********************************************************************/
/*! exports provided: m-accordion-group, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-accordion-group\":{\"open-all\":\"Tout ouvrir\",\"close-all\":\"Tout fermer\"}}");

/***/ }),

/***/ "./src/components/accordion/accordion.lang.fr.json":
/*!*********************************************************!*\
  !*** ./src/components/accordion/accordion.lang.fr.json ***!
  \*********************************************************/
/*! exports provided: m-accordion, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-accordion\":{\"open\":\"Afficher le contenu\",\"close\":\"Cacher le contenu\"}}");

/***/ }),

/***/ "./src/components/address/address-editor/address-editor.lang.fr.json":
/*!***************************************************************************!*\
  !*** ./src/components/address/address-editor/address-editor.lang.fr.json ***!
  \***************************************************************************/
/*! exports provided: m-address-editor, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-address-editor\":{\"building-number\":\"Numéro civique\",\"sub-building\":\"Unité\",\"street\":\"Rue\",\"city\":\"Ville\",\"country\":\"Pays\",\"province\":\"Province / état\",\"postal-code\":\"Code Postal\"}}");

/***/ }),

/***/ "./src/components/address/address-lookup-field/address-lookup-field.lang.fr.json":
/*!***************************************************************************************!*\
  !*** ./src/components/address/address-lookup-field/address-lookup-field.lang.fr.json ***!
  \***************************************************************************************/
/*! exports provided: m-address-lookup-field, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-address-lookup-field\":{\"search-field\":\"Rechercher une adresse\",\"placeholder\":\"Entrez une adresse à rechercher\"}}");

/***/ }),

/***/ "./src/components/calendar/calendar.lang.fr.json":
/*!*******************************************************!*\
  !*** ./src/components/calendar/calendar.lang.fr.json ***!
  \*******************************************************/
/*! exports provided: m-calendar, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-calendar\":{\"previous.month\":\"Mois précédent\",\"previous.year\":\"Année précédente\",\"next.month\":\"Mois suivant\",\"next.year\":\"Année suivante\",\"month.january\":\"Janvier\",\"month.february\":\"Février\",\"month.march\":\"Mars\",\"month.april\":\"Avril\",\"month.may\":\"Mai\",\"month.june\":\"Juin\",\"month.july\":\"Juillet\",\"month.august\":\"Août\",\"month.september\":\"Septembre\",\"month.october\":\"Octobre\",\"month.november\":\"Novembre\",\"month.december\":\"Décembre\",\"month.january.short\":\"Janv.\",\"month.february.short\":\"Févr.\",\"month.march.short\":\"Mars\",\"month.april.short\":\"Avril\",\"month.may.short\":\"Mai\",\"month.june.short\":\"Juin\",\"month.july.short\":\"Juil.\",\"month.august.short\":\"Août\",\"month.september.short\":\"Sept.\",\"month.october.short\":\"Oct.\",\"month.november.short\":\"Nov.\",\"month.december.short\":\"Déc.\",\"weekday.sunday\":\"Dimanche\",\"weekday.monday\":\"Lundi\",\"weekday.tuesday\":\"Mardi\",\"weekday.wednesday\":\"Mercredi\",\"weekday.thursday\":\"Jeudi\",\"weekday.friday\":\"Vendredi\",\"weekday.saturday\":\"Samedi\",\"weekday.sunday.short\":\"Dim.\",\"weekday.monday.short\":\"Lun.\",\"weekday.tuesday.short\":\"Mar.\",\"weekday.wednesday.short\":\"Mer.\",\"weekday.thursday.short\":\"Jeu.\",\"weekday.friday.short\":\"Ven.\",\"weekday.saturday.short\":\"Sam.\"}}");

/***/ }),

/***/ "./src/components/chip/chip.lang.fr.json":
/*!***********************************************!*\
  !*** ./src/components/chip/chip.lang.fr.json ***!
  \***********************************************/
/*! exports provided: chip, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"chip\":{\"add\":\"Ajouter\",\"delete\":\"Supprimer\"}}");

/***/ }),

/***/ "./src/components/copy-to-clipboard/copy-to-clipboard.lang.fr.json":
/*!*************************************************************************!*\
  !*** ./src/components/copy-to-clipboard/copy-to-clipboard.lang.fr.json ***!
  \*************************************************************************/
/*! exports provided: m-copy-to-clipboard, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-copy-to-clipboard\":{\"copy\":\"Copier\",\"copied\":\"Copié\"}}");

/***/ }),

/***/ "./src/components/datepicker/datepicker.lang.fr.json":
/*!***********************************************************!*\
  !*** ./src/components/datepicker/datepicker.lang.fr.json ***!
  \***********************************************************/
/*! exports provided: m-datepicker, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-datepicker\":{\"placeholder-aaaa-mm-jj\":\"AAAA-MM-JJ\",\"placeholder-aaaa-mm\":\"AAAA-MM\",\"open\":\"Ouvrir le calendrier\",\"close\":\"Fermer le calendrier\",\"out-of-range-error\":\"Date hors limites\",\"format-error\":\"Entrez une date au format AAAA-MM-JJ\"}}");

/***/ }),

/***/ "./src/components/daterangepicker/daterangepicker.lang.fr.json":
/*!*********************************************************************!*\
  !*** ./src/components/daterangepicker/daterangepicker.lang.fr.json ***!
  \*********************************************************************/
/*! exports provided: m-daterangepicker, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-daterangepicker\":{\"label.from\":\"Du\",\"label.to\":\"Au\"}}");

/***/ }),

/***/ "./src/components/dialog/dialog.lang.fr.json":
/*!***************************************************!*\
  !*** ./src/components/dialog/dialog.lang.fr.json ***!
  \***************************************************/
/*! exports provided: m-dialog, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-dialog\":{\"cancel\":\"Annuler\",\"ok\":\"Ok\"}}");

/***/ }),

/***/ "./src/components/dropdown/dropdown.lang.fr.json":
/*!*******************************************************!*\
  !*** ./src/components/dropdown/dropdown.lang.fr.json ***!
  \*******************************************************/
/*! exports provided: m-dropdown, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-dropdown\":{\"no-data\":\"Aucune donnée\",\"no-result\":\"Aucun résultat\",\"none\":\"(Aucun)\",\"research\":\"Recherche\",\"search\":\"Rechercher\",\"open\":\"Ouvrir la liste déroulante\",\"close\":\"Fermer la liste déroulante\"}}");

/***/ }),

/***/ "./src/components/error-pages/error-access-denied/error-access-denied.lang.fr.json":
/*!*****************************************************************************************!*\
  !*** ./src/components/error-pages/error-access-denied/error-access-denied.lang.fr.json ***!
  \*****************************************************************************************/
/*! exports provided: m-error-access-denied, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-error-access-denied\":{\"title\":\"Vous n'avez pas les privilèges<br>pour voir cette page\",\"hint.primary\":\"Si vous croyez que cette situation est anormale, contactez le soutien technique.\",\"help\":\"Coordonnées du soutien technique\"}}");

/***/ }),

/***/ "./src/components/error-pages/error-browser-not-supported/error-browser-not-supported.lang.fr.json":
/*!*********************************************************************************************************!*\
  !*** ./src/components/error-pages/error-browser-not-supported/error-browser-not-supported.lang.fr.json ***!
  \*********************************************************************************************************/
/*! exports provided: m-error-browser-not-supported, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-error-browser-not-supported\":{\"title\":\"Ce navigateur<br>n'est pas compatible\",\"hint.primary.desktop\":\"Une mise à niveau de votre navigateur est nécessaire pour accéder ce site.\",\"hint.primary.mobile\":\"Une mise à niveau de votre navigateur est nécessaire pour accéder à ce site. Pour ce faire, consulter la boutique de téléchargement d'application de votre appareil\",\"update-browser.desktop\":\"Mettre mon navigateur à niveau\"}}");

/***/ }),

/***/ "./src/components/error-pages/error-config-not-supported/error-config-not-supported.lang.fr.json":
/*!*******************************************************************************************************!*\
  !*** ./src/components/error-pages/error-config-not-supported/error-config-not-supported.lang.fr.json ***!
  \*******************************************************************************************************/
/*! exports provided: m-error-config-not-supported, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-error-config-not-supported\":{\"title\":\"L'application pourrait ne pas fonctionner correctement avec ce navigateur<br>ou cet appareil\",\"hint.primary\":\"La version du navigateur ou du système d'exploitation que vous utilisez n'est pas officiellement prise en charge.\",\"hint.secondary\":\"Pour une expérience optimale, assurez-vous d'utiliser la version la plus récente de votre navigateur préféré, sur un système d'exploitation compatible.\"}}");

/***/ }),

/***/ "./src/components/error-pages/error-conflict/error-conflict.lang.fr.json":
/*!*******************************************************************************!*\
  !*** ./src/components/error-pages/error-conflict/error-conflict.lang.fr.json ***!
  \*******************************************************************************/
/*! exports provided: m-error-conflict, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-error-conflict\":{\"title\":\"Quelqu'un d'autre a aussi modifié cette page\",\"hint.primary\":\"Certains de vos changements peuvent avoir été perdus. Vérifier le contenu de la page et apportez-y des modifications si nécessaire.\"}}");

/***/ }),

/***/ "./src/components/error-pages/error-cookies-not-supported/error-cookies-not-supported.lang.fr.json":
/*!*********************************************************************************************************!*\
  !*** ./src/components/error-pages/error-cookies-not-supported/error-cookies-not-supported.lang.fr.json ***!
  \*********************************************************************************************************/
/*! exports provided: m-error-cookies-not-supported, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-error-cookies-not-supported\":{\"title\":\"Les cookies sont désactivés<br>dans votre navigateur\",\"hint.primary\":\"Pour accéder à ce site, modifiez les paramètres de votre navigateur et réessayez.\",\"home-label\":\"Accueil\"}}");

/***/ }),

/***/ "./src/components/error-pages/error-page-not-found/error-page-not-found.lang.fr.json":
/*!*******************************************************************************************!*\
  !*** ./src/components/error-pages/error-page-not-found/error-page-not-found.lang.fr.json ***!
  \*******************************************************************************************/
/*! exports provided: m-error-page-not-found, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-error-page-not-found\":{\"title\":\"La page demandée<br>n'a pas été trouvée\",\"hint.primary\":\"Elle a peut-être été déplacée ou retirée, ou son nom a changé. Vous pouvez vérifier l'adresse (URL) indiquée dans votre navigateur et réessayer.\",\"home-label\":\"Accueil\"}}");

/***/ }),

/***/ "./src/components/error-pages/error-resource-unavailable/error-resource-unavailable.lang.fr.json":
/*!*******************************************************************************************************!*\
  !*** ./src/components/error-pages/error-resource-unavailable/error-resource-unavailable.lang.fr.json ***!
  \*******************************************************************************************************/
/*! exports provided: m-error-resource-unavailable, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-error-resource-unavailable\":{\"title\":\"Cette section est actuellement indisponible.\",\"hint.primary\":\"Nous travaillons à rétablir la situation dans les meilleurs délais.\",\"home-label\":\"Accueil\"}}");

/***/ }),

/***/ "./src/components/error-pages/error-session-expired/error-session-expired.lang.fr.json":
/*!*********************************************************************************************!*\
  !*** ./src/components/error-pages/error-session-expired/error-session-expired.lang.fr.json ***!
  \*********************************************************************************************/
/*! exports provided: m-session-expired, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-session-expired\":{\"message\":\"Votre session de travail est expirée.\",\"directions-1\":\"En raison d'une trop grande période d'inactivité ou parce que vous vous êtes déconnecté d’un système partenaire, votre session de travail a été interrompue.\",\"directions-2\":\"Vous devrez peut-être vous connecter de nouveau.\",\"back-to-portal\":\"Retour au portail\"}}");

/***/ }),

/***/ "./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.lang.fr.json":
/*!*******************************************************************************************************!*\
  !*** ./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.lang.fr.json ***!
  \*******************************************************************************************************/
/*! exports provided: m-error-technical-difficulty, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-error-technical-difficulty\":{\"title\":\"Un problème technique<br>s'est produit\",\"hint.primary\":\"Essayez de rafraîchir la page.\",\"hint.secondary\":\"Si le problème persiste, vous pouvez contacter l'équipe de soutien et leur fournir les précisions techniques ci-dessous.\",\"details\":\"Précisions techniques\",\"browser\":\"Navigateur\",\"reference-number\":\"No référence de l'erreur\",\"system\":\"Système de l'erreur\",\"date.primary\":\"Elle a eu lieu le \",\"date.secondary\":\" à \",\"help\":\"Pour obtenir de l'aide, contactez le soutien technique\",\"home-label\":\"Coordonnées du soutien technique\"}}");

/***/ }),

/***/ "./src/components/file-select/file-select.lang.fr.json":
/*!*************************************************************!*\
  !*** ./src/components/file-select/file-select.lang.fr.json ***!
  \*************************************************************/
/*! exports provided: m-select-file, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-select-file\":{\"label\":\"Parcourir\"}}");

/***/ }),

/***/ "./src/components/file-upload/file-upload.lang.fr.json":
/*!*************************************************************!*\
  !*** ./src/components/file-upload/file-upload.lang.fr.json ***!
  \*************************************************************/
/*! exports provided: m-file-upload, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-file-upload\":{\"header-title\":\"Ajouter un fichier\",\"header-title.p\":\"Ajouter des fichiers\",\"header-title-file-replacement\":\"Remplacer le fichier\",\"dropFile\":\"Déposer le fichier ici ou\",\"dropFile.p\":\"Déposer les fichiers ici ou\",\"selectFile\":\"Sélectionner un fichier\",\"selectFile.p\":\"Sélectionner des fichiers\",\"format\":\"Format accepté%(_NBSP_)s\",\"format.p\":\"Formats acceptés%(_NBSP_)s\",\"import\":\"En cours d'importation\",\"file\":\"fichier\",\"file.p\":\"fichiers\",\"add\":\"Ajouter\",\"replace\":\"Remplacer\",\"cancel\":\"Annuler\",\"rejectFileMsg\":\"Le fichier suivant ne peut être ajouté.\",\"rejectFileMsg.p\":\"Les fichiers suivants ne peuvent être ajoutés.\",\"extensionFileMsg\":\"L'extension du fichier n’est pas acceptée.\",\"maxSizeMsg\":\"Le fichier est refusé, car sa taille dépasse la limite permise\",\"maxNumberMsg\":\"Le nombre maximal de fichiers pouvant être ajoutés simultanément est atteint\",\"errorMsg\":\"Une erreur s'est produite durant le téléversement.\",\"cancelFileUpload\":\"Annuler le téléversement\",\"deleteUploadedFile\":\"Supprimer le fichier téléversé\"}}");

/***/ }),

/***/ "./src/components/form/form.lang.fr.json":
/*!***********************************************!*\
  !*** ./src/components/form/form.lang.fr.json ***!
  \***********************************************/
/*! exports provided: m-form, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-form\":{\"multipleErrorsToCorrect\":\"<strong>%(totalNbOfErrors)s information</strong> à revoir pour continuer.\",\"multipleErrorsToCorrect.p\":\"<strong>%(totalNbOfErrors)s informations</strong> à revoir pour continuer.\",\"requiredValidatorErrorMessage\":\"Ce champ est requis.\",\"requiredValidatorErrorSummaryMessage\":\"Le champ %(controlLabel)s est requis.\",\"minLengthValidatorErrorMessage\":\"Le nombre minimal de caractères pour ce champ est %(minLength)s.\",\"minLengthValidatorErrorSummaryMessage\":\"Le nombre minimal de caractères pour le champ %(controlLabel)s est %(minLength)s.\",\"maxLengthValidatorErrorMessage\":\"Le nombre maximal de caractères pour ce champ est %(maxLength)s.\",\"maxLengthValidatorErrorSummaryMessage\":\"Le nombre maximal de caractères pour le champ %(controlLabel)s est %(maxLength)s.\",\"minValidatorErrorMessage\":\"La valeur minimal de ce champ est %(min)s.\",\"minValidatorErrorSummaryMessage\":\"La valeur minimal du champ %(controlLabel)s est %(min)s.\",\"maxValidatorErrorMessage\":\"La valeur maximal de ce champ est %(max)s.\",\"maxValidatorErrorSummaryMessage\":\"La valeur maximal du champ %(controlLabel)s est %(max)s.\",\"betweenValidatorErrorMessage\":\"La valeur doit être entre %(lowerBound)s et %(upperBound)s.\",\"betweenValidatorErrorSummaryMessage\":\"La valeur du champ %(controlLabel)s doit être entre %(lowerBound)s et %(upperBound)s.\",\"emailValidatorErrorMessage\":\"Le format de l'adresse courriel est invalide.\",\"emailValidatorErrorSummaryMessage\":\"Le format de l'adresse courriel pour %(controlLabel)s est invalide.\",\"compareValidatorErrorMessage\":\"Les valeurs du groupe %(controlLabels)s doivent être identiques.\",\"compareValidatorErrorSummaryMessage\":\"Les valeurs du groupe %(controlLabels)s doivent être identiques.\",\"compareValidatorErrorMessageNoName\":\"Les valeurs de ce groupe doivent être identiques.\",\"dateFormatValidatorErrorMessage\":\"Entrez une date avec un format AAAA-MM-JJ\",\"dateFormValidatorErrorSummaryMessage\":\"Le format de la date est AAAA-MM-JJ pour %(controlLabel)s\",\"dateBetweenValidatorErrorMessage\":\"Entrez une date comprise entre le %(start)s et le %(end)s\",\"dateBetweenValidatorErrorSummaryMessage\":\"La date doit être comprise entre le %(start)s et le %(end)s pour %(controlLabel)s\",\"phoneValidatorErrorMessage\":\"Le numéro de téléphone est invalide.\",\"phoneValidatorErrorSummaryMessage\":\"Le numéro de téléphone pour %(controlLabel)s est invalide.\"}}");

/***/ }),

/***/ "./src/components/icon-file/icon-file.lang.fr.json":
/*!*********************************************************!*\
  !*** ./src/components/icon-file/icon-file.lang.fr.json ***!
  \*********************************************************/
/*! exports provided: m-icon-file, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-icon-file\":{\"prefix\":\"Type du fichier: \",\"image\":\"Image\",\"txt\":\"Texte\",\"doc\":\"Document Word\",\"vsd\":\"Diagramme Visio\",\"ppt\":\"Présentation Powerpoint\",\"xls\":\"Tableur Excel\",\"accdb\":\"Base de données Access\",\"pdf\":\"Document PDF\",\"rm\":\"Audio RealMedia\",\"mov\":\"Vidéo Quicktime\",\"wma\":\"Vidéo Windows Media\",\"swf\":\"Flash\",\"video\":\"Vidéo mpeg\",\"music\":\"Audio\",\"zip\":\"Archive\",\"openoffice1\":\"Document Open Office\",\"odt\":\"Document Open Document\",\"odp\":\"Présentation Open Document\",\"odg\":\"Dessin Open Document\",\"ods\":\"Tableur Open Document\",\"odf\":\"Formule mathématique Open Document\",\"odb\":\"Base de données Open Document\",\"spss\":\"Statistiques SPSS\",\"dwg\":\"Dessin AutoCAD\",\"enl\":\"Bibliographie EndNote\",\"sas\":\"Statistiques SAS\",\"xml\":\"Format de données XML\",\"html\":\"HTML\",\"css\":\"Feuille de style en cascade\",\"json\":\"Format de données JSON\",\"js\":\"Code\",\"default\":\"Fichier non reconnu\"}}");

/***/ }),

/***/ "./src/components/inplace-edit/inplace-edit.lang.fr.json":
/*!***************************************************************!*\
  !*** ./src/components/inplace-edit/inplace-edit.lang.fr.json ***!
  \***************************************************************/
/*! exports provided: m-inplace-edit, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-inplace-edit\":{\"save\":\"Enregistrer\",\"cancel\":\"Annuler\",\"modify\":\"Modifier\"}}");

/***/ }),

/***/ "./src/components/input-style/input-style.lang.fr.json":
/*!*************************************************************!*\
  !*** ./src/components/input-style/input-style.lang.fr.json ***!
  \*************************************************************/
/*! exports provided: m-input-style, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-input-style\":{\"empty-value\":\"Aucune valeur\"}}");

/***/ }),

/***/ "./src/components/limit-elements/limit-elements.lang.fr.json":
/*!*******************************************************************!*\
  !*** ./src/components/limit-elements/limit-elements.lang.fr.json ***!
  \*******************************************************************/
/*! exports provided: m-limit-elements, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-limit-elements\":{\"show-more-label\":\"Afficher %(nbElements)s de plus\",\"show-less-label\":\"Afficher moins\"}}");

/***/ }),

/***/ "./src/components/limit-text/limit-text.lang.fr.json":
/*!***********************************************************!*\
  !*** ./src/components/limit-text/limit-text.lang.fr.json ***!
  \***********************************************************/
/*! exports provided: m-limit-text, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-limit-text\":{\"open\":\"Afficher le texte complet\",\"close\":\"Réduire l'affichage\"}}");

/***/ }),

/***/ "./src/components/link/link.lang.fr.json":
/*!***********************************************!*\
  !*** ./src/components/link/link.lang.fr.json ***!
  \***********************************************/
/*! exports provided: m-link, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-link\":{\"open-new-tab\":\"Cet hyperlien s'ouvrira dans un nouvel onglet.\"}}");

/***/ }),

/***/ "./src/components/list-item/list-item.lang.fr.json":
/*!*********************************************************!*\
  !*** ./src/components/list-item/list-item.lang.fr.json ***!
  \*********************************************************/
/*! exports provided: m-list-item, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-list-item\":{\"delete\":\"Supprimer\"}}");

/***/ }),

/***/ "./src/components/menu/menu.lang.fr.json":
/*!***********************************************!*\
  !*** ./src/components/menu/menu.lang.fr.json ***!
  \***********************************************/
/*! exports provided: m-menu, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-menu\":{\"open\":\"Ouvrir le menu\",\"close\":\"Fermer le menu\"}}");

/***/ }),

/***/ "./src/components/message/message.lang.fr.json":
/*!*****************************************************!*\
  !*** ./src/components/message/message.lang.fr.json ***!
  \*****************************************************/
/*! exports provided: m-message, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-message\":{\"close\":\"Fermer\"}}");

/***/ }),

/***/ "./src/components/modal/modal.lang.fr.json":
/*!*************************************************!*\
  !*** ./src/components/modal/modal.lang.fr.json ***!
  \*************************************************/
/*! exports provided: m-modal, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-modal\":{\"close\":\"Fermer\"}}");

/***/ }),

/***/ "./src/components/multi-select/multi-select.lang.fr.json":
/*!***************************************************************!*\
  !*** ./src/components/multi-select/multi-select.lang.fr.json ***!
  \***************************************************************/
/*! exports provided: m-multi-select, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-multi-select\":{\"open\":\"Ouvrir la liste déroulante\",\"close\":\"Fermer la liste déroulante\",\"link-select-all\":\"Tout sélectionner\",\"link-deselect-all\":\"Tout désélectionner\",\"all-selected\":\"Tous les choix ({0})\",\"more\":\"{0} de plus...\"}}");

/***/ }),

/***/ "./src/components/option/option.lang.fr.json":
/*!***************************************************!*\
  !*** ./src/components/option/option.lang.fr.json ***!
  \***************************************************/
/*! exports provided: m-option, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-option\":{\"open\":\"Ouvrir le menu\",\"close\":\"Fermer le menu\",\"add\":\"Ajouter\",\"edit\":\"Modifier\",\"delete\":\"Supprimer\",\"archive\":\"Archiver\"}}");

/***/ }),

/***/ "./src/components/organize-table-columns-modal/organize-table-columns-modal.lang.fr.json":
/*!***********************************************************************************************!*\
  !*** ./src/components/organize-table-columns-modal/organize-table-columns-modal.lang.fr.json ***!
  \***********************************************************************************************/
/*! exports provided: m-organize-table-columns-modal, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-organize-table-columns-modal\":{\"title\":\"Réorganiser les colonnes\",\"action.reorganize\":\"Réorganiser\",\"action.reset\":\"Annuler\"}}");

/***/ }),

/***/ "./src/components/organize-table-columns-modal/organize-table-columns/organize-table-columns.lang.fr.json":
/*!****************************************************************************************************************!*\
  !*** ./src/components/organize-table-columns-modal/organize-table-columns/organize-table-columns.lang.fr.json ***!
  \****************************************************************************************************************/
/*! exports provided: m-organize-table-columns, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-organize-table-columns\":{\"title\":\"Ajouter des%(_NBSP_)scolonnes au%(_NBSP_)stableau, puis%(_NBSP_)sorganisez-les\",\"helper-1\":\"Colonnes sélectionnées\",\"helper-2\":\"Colonnes disponibles\",\"add-column\":\"Ajouter la%(_NBSP_)scolonne\",\"error.fixed1\":\"Une colonne ne%(_NBSP_)speut%(_NBSP_)spas être fix et%(_NBSP_)sinvisible.\",\"error.fixed2\":\"Une colonne ne%(_NBSP_)speut%(_NBSP_)spas être fix après une%(_NBSP_)scolonne qui ne%(_NBSP_)sl'est%(_NBSP_)spas.\"}}");

/***/ }),

/***/ "./src/components/overlay/overlay.lang.fr.json":
/*!*****************************************************!*\
  !*** ./src/components/overlay/overlay.lang.fr.json ***!
  \*****************************************************/
/*! exports provided: m-overlay, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-overlay\":{\"save\":\"Enregistrer\",\"cancel\":\"Annuler\"}}");

/***/ }),

/***/ "./src/components/pagination/pagination.lang.fr.json":
/*!***********************************************************!*\
  !*** ./src/components/pagination/pagination.lang.fr.json ***!
  \***********************************************************/
/*! exports provided: m-pagination, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-pagination\":{\"previous\":\"Page précédente\",\"next\":\"Page suivante\",\"ellipsis\":\"...\",\"status-single\":\"%(nbResults)s résultat\",\"status-single.p\":\"%(nbResults)s résultats\",\"status.p\":\"%(idxFirst)s à %(idxLast)s de %(nbResults)s résultats\"}}");

/***/ }),

/***/ "./src/components/photo-editor/photo-editor.lang.fr.json":
/*!***************************************************************!*\
  !*** ./src/components/photo-editor/photo-editor.lang.fr.json ***!
  \***************************************************************/
/*! exports provided: m-photo-editor, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-photo-editor\":{\"title\":\"Photo de profil\",\"choose-photo\":\"Choisir une photo\",\"cancel\":\"Annuler\",\"save\":\"Enregistrer\",\"delete\":\"Supprimer\",\"error-file\":\"Veuillez choisir une image de format %(extensions)s\"}}");

/***/ }),

/***/ "./src/components/repeater/repeater.lang.fr.json":
/*!*******************************************************!*\
  !*** ./src/components/repeater/repeater.lang.fr.json ***!
  \*******************************************************/
/*! exports provided: m-repeater, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-repeater\":{\"add\":\"Ajouter\",\"delete\":\"Supprimer\"}}");

/***/ }),

/***/ "./src/components/rich-text-editor/rich-text-editor.lang.fr.json":
/*!***********************************************************************!*\
  !*** ./src/components/rich-text-editor/rich-text-editor.lang.fr.json ***!
  \***********************************************************************/
/*! exports provided: m-rich-text-editor, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-rich-text-editor\":{\"hide-submenu\":\"Cacher le sous menu\",\"image-block-center\":\"Centrer\",\"image-block-left\":\"Aligner à gauche\",\"image-float-left\":\"Afficher en vignette à gauche\",\"image-float-right\":\"Afficher en vignette à droite\",\"image-layout\":\"Disposition de l'image\",\"insert\":\"insertions\",\"insert-image\":\"Insérer une image\",\"lists\":\"listes\",\"normal-level\":\"Normal\",\"replace-image\":\"Remplacer l'image\",\"styles\":\"styles\",\"subtitle\":\"Sous-titre\",\"title\":\"Titre\",\"title-level\":\"Titre %(headerLevel)s\",\"URL\":\"URL ou courriel\"}}");

/***/ }),

/***/ "./src/components/scroll-top/scroll-top.lang.fr.json":
/*!***********************************************************!*\
  !*** ./src/components/scroll-top/scroll-top.lang.fr.json ***!
  \***********************************************************/
/*! exports provided: m-scroll-top, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-scroll-top\":{\"top\":\"Défiler en haut de page\"}}");

/***/ }),

/***/ "./src/components/select/select.lang.fr.json":
/*!***************************************************!*\
  !*** ./src/components/select/select.lang.fr.json ***!
  \***************************************************/
/*! exports provided: m-select, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-select\":{\"open\":\"Ouvrir la liste déroulante\",\"close\":\"Fermer la liste déroulante\"}}");

/***/ }),

/***/ "./src/components/show-more/show-more.lang.fr.json":
/*!*********************************************************!*\
  !*** ./src/components/show-more/show-more.lang.fr.json ***!
  \*********************************************************/
/*! exports provided: m-show-more, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-show-more\":{\"status\":\"%(nbVisible)s sur %(nbTotal)s\",\"button-label\":\"Afficher plus de résultats\"}}");

/***/ }),

/***/ "./src/components/sidebar/sidebar.lang.fr.json":
/*!*****************************************************!*\
  !*** ./src/components/sidebar/sidebar.lang.fr.json ***!
  \*****************************************************/
/*! exports provided: m-sidebar, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-sidebar\":{\"close\":\"Fermer\"}}");

/***/ }),

/***/ "./src/components/spinner/spinner.lang.fr.json":
/*!*****************************************************!*\
  !*** ./src/components/spinner/spinner.lang.fr.json ***!
  \*****************************************************/
/*! exports provided: m-spinner, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-spinner\":{\"loading\":\"Chargement en cours\",\"processing\":\"Traitement en cours\",\"description\":\"Veuillez patienter svp.\"}}");

/***/ }),

/***/ "./src/components/switch/switch.lang.fr.json":
/*!***************************************************!*\
  !*** ./src/components/switch/switch.lang.fr.json ***!
  \***************************************************/
/*! exports provided: m-switch, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-switch\":{\"yes\":\"Oui\",\"no\":\"Non\"}}");

/***/ }),

/***/ "./src/components/table/table.lang.fr.json":
/*!*************************************************!*\
  !*** ./src/components/table/table.lang.fr.json ***!
  \*************************************************/
/*! exports provided: m-table, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-table\":{\"no-data\":\"Aucune donnée à afficher\",\"loading\":\"Chargement en cours\",\"please-wait\":\"Veuillez patienter svp.\",\"sort\":\"Trier la colonne\"}}");

/***/ }),

/***/ "./src/components/textfield/textfield.lang.fr.json":
/*!*********************************************************!*\
  !*** ./src/components/textfield/textfield.lang.fr.json ***!
  \*********************************************************/
/*! exports provided: m-textfield, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-textfield\":{\"show-password\":\"Afficher le mot de passe\",\"hide-password\":\"Masquer le mot de passe\",\"search\":\"Rechercher\"}}");

/***/ }),

/***/ "./src/components/timepicker/timepicker.lang.fr.json":
/*!***********************************************************!*\
  !*** ./src/components/timepicker/timepicker.lang.fr.json ***!
  \***********************************************************/
/*! exports provided: m-timepicker, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-timepicker\":{\"button-ok\":\"OK\",\"placeholder\":\"HH:MM\",\"hours\":\"Heures\",\"minutes\":\"Minutes\",\"open\":\"Ouvrir le sélecteur d'heure\",\"close\":\"Fermer le sélecteur d'heure'\",\"out-of-bounds-error\":\"Entrez une heure comprise entre %(min)s et %(max)s\",\"error-format\":\"Entrez une heure au format HH:MM\"}}");

/***/ }),

/***/ "./src/components/toast/toast.lang.fr.json":
/*!*************************************************!*\
  !*** ./src/components/toast/toast.lang.fr.json ***!
  \*************************************************/
/*! exports provided: m-toast, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-toast\":{\"close\":\"Fermer\"}}");

/***/ }),

/***/ "./src/components/tooltip/tooltip.lang.fr.json":
/*!*****************************************************!*\
  !*** ./src/components/tooltip/tooltip.lang.fr.json ***!
  \*****************************************************/
/*! exports provided: m-tooltip, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-tooltip\":{\"open\":\"Ouvrir l'infobulle\",\"close\":\"Fermer l'infobulle\"}}");

/***/ }),

/***/ "./src/components/tree/tree.lang.fr.json":
/*!***********************************************!*\
  !*** ./src/components/tree/tree.lang.fr.json ***!
  \***********************************************/
/*! exports provided: m-tree, m-tree-node, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-tree\":{\"empty\":\"Aucun contenu\",\"error\":\"Certains éléments n'ont pas pu être affichés dû à un problème technique.\"},\"m-tree-node\":{\"empty\":\"Aucun contenu\"}}");

/***/ }),

/***/ "./src/components/typeahead/typeahead.lang.fr.json":
/*!*********************************************************!*\
  !*** ./src/components/typeahead/typeahead.lang.fr.json ***!
  \*********************************************************/
/*! exports provided: m-typeahead, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-typeahead\":{\"research\":\"Recherche\",\"search\":\"Rechercher\"}}");

/***/ }),

/***/ "./src/components/validation-message/validation-message.lang.fr.json":
/*!***************************************************************************!*\
  !*** ./src/components/validation-message/validation-message.lang.fr.json ***!
  \***************************************************************************/
/*! exports provided: m-validation-message, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"m-validation-message\":{\"title-error-icon\":\"Erreur\",\"title-valid-icon\":\"Valide\"}}");

/***/ }),

/***/ "./src/filters/date/date-time/date-time.lang.fr.json":
/*!***********************************************************!*\
  !*** ./src/filters/date/date-time/date-time.lang.fr.json ***!
  \***********************************************************/
/*! exports provided: f-m-date-time, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"f-m-date-time\":{\"long\":\"%(date)s à %(time)s\",\"short\":\"%(date)s %(time)s\"}}");

/***/ }),

/***/ "./src/filters/date/date/date.lang.fr.json":
/*!*************************************************!*\
  !*** ./src/filters/date/date/date.lang.fr.json ***!
  \*************************************************/
/*! exports provided: f-m-date, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"f-m-date\":{\"long\":\"[$]Do[$] MMMM YYYY\",\"short\":\"[$]Do[$] MMM YYYY\"}}");

/***/ }),

/***/ "./src/filters/date/period/period.lang.fr.json":
/*!*****************************************************!*\
  !*** ./src/filters/date/period/period.lang.fr.json ***!
  \*****************************************************/
/*! exports provided: f-m-period, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"f-m-period\":{\"dates\":\"Du %(start)s au %(end)s\",\"start\":\"Débute le %(start)s\",\"end\":\"Se termine le %(end)s\",\"sameDay\":\"Le %(date)s\",\"sameDayShowTime\":\"Le %(date)s %(time)s\"}}");

/***/ }),

/***/ "./src/filters/date/time-elapsed/time-elapsed.lang.fr.json":
/*!*****************************************************************!*\
  !*** ./src/filters/date/time-elapsed/time-elapsed.lang.fr.json ***!
  \*****************************************************************/
/*! exports provided: f-m-time-elapsed, f-m-time-elapsed-start-sentence, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"f-m-time-elapsed\":{\"now\":\"à l'instant\",\"minute\":\"il y a %(minute)s minute\",\"minute.p\":\"il y a %(minute)s minutes\",\"hour\":\"il y a %(hour)s heure\",\"hour.p\":\"il y a %(hour)s heures\",\"day\":\"il y a %(day)s jour\",\"day.p\":\"il y a %(day)s jours\"},\"f-m-time-elapsed-start-sentence\":{\"now\":\"À l'instant\",\"minute\":\"Il y a %(minute)s minute\",\"minute.p\":\"Il y a %(minute)s minutes\",\"hour\":\"Il y a %(hour)s heure\",\"hour.p\":\"Il y a %(hour)s heures\",\"day\":\"Il y a %(day)s jour\",\"day.p\":\"Il y a %(day)s jours\"}}");

/***/ }),

/***/ "./src/filters/date/time/time.lang.fr.json":
/*!*************************************************!*\
  !*** ./src/filters/date/time/time.lang.fr.json ***!
  \*************************************************/
/*! exports provided: f-m-time, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"f-m-time\":{\"timeOnly\":\"%(time)s\",\"atTime\":\"À %(time)s\",\"fromTime\":\"À partir de %(time)s\",\"untilTime\":\"Jusqu'à %(time)s\",\"timePeriod\":\"%(from)s - %(to)s\",\"timePeriodWithPreposition\":\"De %(from)s à %(to)s\"}}");

/***/ }),

/***/ "./src/filters/filesize/filesize.lang.fr.json":
/*!****************************************************!*\
  !*** ./src/filters/filesize/filesize.lang.fr.json ***!
  \****************************************************/
/*! exports provided: f-m-filesize, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"f-m-filesize\":{\"size-b\":\"o\",\"size-kb\":\"ko\",\"size-mb\":\"Mo\",\"size-gb\":\"Go\"}}");

/***/ }),

/***/ "./src/lang/fr.ts":
/*!************************!*\
  !*** ./src/lang/fr.ts ***!
  \************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/i18n/i18n */ "./src/utils/i18n/i18n.ts");

var FrenchPlugin = {
    install: function (v, options) {
        v.prototype.$log.debug('FrenchPlugin', 'plugin.install');
        var i18n = (v.prototype).$i18n;
        if (i18n) {
            var msgs = [
                __webpack_require__(/*! ../components/accordion/accordion.lang.fr.json */ "./src/components/accordion/accordion.lang.fr.json"),
                __webpack_require__(/*! ../components/accordion-group/accordion-group.lang.fr.json */ "./src/components/accordion-group/accordion-group.lang.fr.json"),
                __webpack_require__(/*! ../components/address/address-editor/address-editor.lang.fr.json */ "./src/components/address/address-editor/address-editor.lang.fr.json"),
                __webpack_require__(/*! ../components/address/address-lookup-field/address-lookup-field.lang.fr.json */ "./src/components/address/address-lookup-field/address-lookup-field.lang.fr.json"),
                __webpack_require__(/*! ../components/calendar/calendar.lang.fr.json */ "./src/components/calendar/calendar.lang.fr.json"),
                __webpack_require__(/*! ../components/chip/chip.lang.fr.json */ "./src/components/chip/chip.lang.fr.json"),
                __webpack_require__(/*! ../components/copy-to-clipboard/copy-to-clipboard.lang.fr.json */ "./src/components/copy-to-clipboard/copy-to-clipboard.lang.fr.json"),
                __webpack_require__(/*! ../components/datepicker/datepicker.lang.fr.json */ "./src/components/datepicker/datepicker.lang.fr.json"),
                __webpack_require__(/*! ../components/daterangepicker/daterangepicker.lang.fr.json */ "./src/components/daterangepicker/daterangepicker.lang.fr.json"),
                __webpack_require__(/*! ../components/dialog/dialog.lang.fr.json */ "./src/components/dialog/dialog.lang.fr.json"),
                __webpack_require__(/*! ../components/dropdown/dropdown.lang.fr.json */ "./src/components/dropdown/dropdown.lang.fr.json"),
                __webpack_require__(/*! ../components/list-item/list-item.lang.fr.json */ "./src/components/list-item/list-item.lang.fr.json"),
                __webpack_require__(/*! ../components/error-pages/error-access-denied/error-access-denied.lang.fr.json */ "./src/components/error-pages/error-access-denied/error-access-denied.lang.fr.json"),
                __webpack_require__(/*! ../components/error-pages/error-browser-not-supported/error-browser-not-supported.lang.fr.json */ "./src/components/error-pages/error-browser-not-supported/error-browser-not-supported.lang.fr.json"),
                __webpack_require__(/*! ../components/error-pages/error-config-not-supported/error-config-not-supported.lang.fr.json */ "./src/components/error-pages/error-config-not-supported/error-config-not-supported.lang.fr.json"),
                __webpack_require__(/*! ../components/error-pages/error-conflict/error-conflict.lang.fr.json */ "./src/components/error-pages/error-conflict/error-conflict.lang.fr.json"),
                __webpack_require__(/*! ../components/error-pages/error-cookies-not-supported/error-cookies-not-supported.lang.fr.json */ "./src/components/error-pages/error-cookies-not-supported/error-cookies-not-supported.lang.fr.json"),
                __webpack_require__(/*! ../components/error-pages/error-page-not-found/error-page-not-found.lang.fr.json */ "./src/components/error-pages/error-page-not-found/error-page-not-found.lang.fr.json"),
                __webpack_require__(/*! ../components/error-pages/error-resource-unavailable/error-resource-unavailable.lang.fr.json */ "./src/components/error-pages/error-resource-unavailable/error-resource-unavailable.lang.fr.json"),
                __webpack_require__(/*! ../components/error-pages/error-technical-difficulty/error-technical-difficulty.lang.fr.json */ "./src/components/error-pages/error-technical-difficulty/error-technical-difficulty.lang.fr.json"),
                __webpack_require__(/*! ../components/error-pages/error-session-expired/error-session-expired.lang.fr.json */ "./src/components/error-pages/error-session-expired/error-session-expired.lang.fr.json"),
                __webpack_require__(/*! ../components/file-select/file-select.lang.fr.json */ "./src/components/file-select/file-select.lang.fr.json"),
                __webpack_require__(/*! ../components/file-upload/file-upload.lang.fr.json */ "./src/components/file-upload/file-upload.lang.fr.json"),
                __webpack_require__(/*! ../components/form/form.lang.fr.json */ "./src/components/form/form.lang.fr.json"),
                __webpack_require__(/*! ../components/icon-file/icon-file.lang.fr.json */ "./src/components/icon-file/icon-file.lang.fr.json"),
                __webpack_require__(/*! ../components/inplace-edit/inplace-edit.lang.fr.json */ "./src/components/inplace-edit/inplace-edit.lang.fr.json"),
                __webpack_require__(/*! ../components/input-style/input-style.lang.fr.json */ "./src/components/input-style/input-style.lang.fr.json"),
                __webpack_require__(/*! ../components/link/link.lang.fr.json */ "./src/components/link/link.lang.fr.json"),
                __webpack_require__(/*! ../components/limit-elements/limit-elements.lang.fr.json */ "./src/components/limit-elements/limit-elements.lang.fr.json"),
                __webpack_require__(/*! ../components/limit-text/limit-text.lang.fr.json */ "./src/components/limit-text/limit-text.lang.fr.json"),
                __webpack_require__(/*! ../components/menu/menu.lang.fr.json */ "./src/components/menu/menu.lang.fr.json"),
                __webpack_require__(/*! ../components/message/message.lang.fr.json */ "./src/components/message/message.lang.fr.json"),
                __webpack_require__(/*! ../components/modal/modal.lang.fr.json */ "./src/components/modal/modal.lang.fr.json"),
                __webpack_require__(/*! ../components/multi-select/multi-select.lang.fr.json */ "./src/components/multi-select/multi-select.lang.fr.json"),
                __webpack_require__(/*! ../components/overlay/overlay.lang.fr.json */ "./src/components/overlay/overlay.lang.fr.json"),
                __webpack_require__(/*! ../components/option/option.lang.fr.json */ "./src/components/option/option.lang.fr.json"),
                __webpack_require__(/*! ../components/organize-table-columns-modal/organize-table-columns-modal.lang.fr.json */ "./src/components/organize-table-columns-modal/organize-table-columns-modal.lang.fr.json"),
                __webpack_require__(/*! ../components/organize-table-columns-modal/organize-table-columns/organize-table-columns.lang.fr.json */ "./src/components/organize-table-columns-modal/organize-table-columns/organize-table-columns.lang.fr.json"),
                __webpack_require__(/*! ../components/pagination/pagination.lang.fr.json */ "./src/components/pagination/pagination.lang.fr.json"),
                __webpack_require__(/*! ../components/photo-editor/photo-editor.lang.fr.json */ "./src/components/photo-editor/photo-editor.lang.fr.json"),
                __webpack_require__(/*! ../components/repeater/repeater.lang.fr.json */ "./src/components/repeater/repeater.lang.fr.json"),
                __webpack_require__(/*! ../components/rich-text-editor/rich-text-editor.lang.fr.json */ "./src/components/rich-text-editor/rich-text-editor.lang.fr.json"),
                __webpack_require__(/*! ../components/select/select.lang.fr.json */ "./src/components/select/select.lang.fr.json"),
                __webpack_require__(/*! ../components/scroll-top/scroll-top.lang.fr.json */ "./src/components/scroll-top/scroll-top.lang.fr.json"),
                __webpack_require__(/*! ../components/show-more/show-more.lang.fr.json */ "./src/components/show-more/show-more.lang.fr.json"),
                __webpack_require__(/*! ../components/sidebar/sidebar.lang.fr.json */ "./src/components/sidebar/sidebar.lang.fr.json"),
                __webpack_require__(/*! ../components/spinner/spinner.lang.fr.json */ "./src/components/spinner/spinner.lang.fr.json"),
                __webpack_require__(/*! ../components/switch/switch.lang.fr.json */ "./src/components/switch/switch.lang.fr.json"),
                __webpack_require__(/*! ../components/table/table.lang.fr.json */ "./src/components/table/table.lang.fr.json"),
                __webpack_require__(/*! ../components/toast/toast.lang.fr.json */ "./src/components/toast/toast.lang.fr.json"),
                __webpack_require__(/*! ../components/tree/tree.lang.fr.json */ "./src/components/tree/tree.lang.fr.json"),
                __webpack_require__(/*! ../components/textfield/textfield.lang.fr.json */ "./src/components/textfield/textfield.lang.fr.json"),
                __webpack_require__(/*! ../components/timepicker/timepicker.lang.fr.json */ "./src/components/timepicker/timepicker.lang.fr.json"),
                __webpack_require__(/*! ../components/tooltip/tooltip.lang.fr.json */ "./src/components/tooltip/tooltip.lang.fr.json"),
                __webpack_require__(/*! ../components/typeahead/typeahead.lang.fr.json */ "./src/components/typeahead/typeahead.lang.fr.json"),
                __webpack_require__(/*! ../components/validation-message/validation-message.lang.fr.json */ "./src/components/validation-message/validation-message.lang.fr.json"),
                __webpack_require__(/*! ../filters/date/date/date.lang.fr.json */ "./src/filters/date/date/date.lang.fr.json"),
                __webpack_require__(/*! ../filters/date/date-time/date-time.lang.fr.json */ "./src/filters/date/date-time/date-time.lang.fr.json"),
                __webpack_require__(/*! ../filters/date/period/period.lang.fr.json */ "./src/filters/date/period/period.lang.fr.json"),
                __webpack_require__(/*! ../filters/date/time/time.lang.fr.json */ "./src/filters/date/time/time.lang.fr.json"),
                __webpack_require__(/*! ../filters/filesize/filesize.lang.fr.json */ "./src/filters/filesize/filesize.lang.fr.json"),
                __webpack_require__(/*! ../filters/date/time-elapsed/time-elapsed.lang.fr.json */ "./src/filters/date/time-elapsed/time-elapsed.lang.fr.json")
            ];
            msgs.forEach(function (msgs) { return i18n.addMessages(_utils_i18n_i18n__WEBPACK_IMPORTED_MODULE_0__["FRENCH"], msgs); });
        }
        else {
            throw new Error('FrenchPlugin.install -> You must use the i18n plugin.');
        }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (FrenchPlugin);


/***/ }),

/***/ "./src/utils/i18n/i18n.ts":
/*!********************************!*\
  !*** ./src/utils/i18n/i18n.ts ***!
  \********************************/
/*! exports provided: FRENCH, ENGLISH, SpecialCharacter, DebugMode, FormatMode, Messages, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FRENCH", function() { return FRENCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENGLISH", function() { return ENGLISH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpecialCharacter", function() { return SpecialCharacter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebugMode", function() { return DebugMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormatMode", function() { return FormatMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Messages", function() { return Messages; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "tslib");
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tslib__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var sprintf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! sprintf-js */ "sprintf-js");
/* harmony import */ var sprintf_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(sprintf_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);



/**
 * This package provides language and locales utilities.
 */
/**
 * French language code.
 */
var FRENCH = 'fr';
/**
 * English language code.
 */
var ENGLISH = 'en';
/**
 * Regex to parse and format messages.
 */
var FORMAT_REGEX = /{\d+}/g;
/**
 * String used as a special characters wrapper
 */
var SPECIAL_CHARACTER_PREFIXE = '_';
var SPECIAL_CHARACTER_SUFIXE = '_';
/**
 * Special characters must be represented as their unicode equivalent \u00xxxx
 */
var SpecialCharacter;
(function (SpecialCharacter) {
    SpecialCharacter["NBSP"] = "160";
    SpecialCharacter["NBHYPHEN"] = "8209";
    SpecialCharacter["EMDASH"] = "8212";
    SpecialCharacter["ENDASH"] = "8211"; // en dash equivalent to unicode :\u002013, HTML entity : &#ndash; => (–)
})(SpecialCharacter || (SpecialCharacter = {}));
var DebugMode;
(function (DebugMode) {
    DebugMode[DebugMode["Throw"] = 0] = "Throw";
    DebugMode[DebugMode["Warn"] = 1] = "Warn";
    DebugMode[DebugMode["Prod"] = 2] = "Prod";
})(DebugMode || (DebugMode = {}));
var FormatMode;
(function (FormatMode) {
    FormatMode["Default"] = "";
    FormatMode["Vsprintf"] = "vsprintf";
    FormatMode["Sprintf"] = "sprintf";
})(FormatMode || (FormatMode = {}));
var Messages = /** @class */ (function () {
    function Messages(options) {
        this.options = options;
        this.curLang = ENGLISH;
        this.messages = {};
        this.specialCharacterDict = {};
        if (options) {
            if (options.curLang) {
                this.currentLang(options.curLang);
            }
            if (options.formatMode) {
                this.formatMode = options.formatMode;
            }
        }
        this.initSpecialCharactersDict();
    }
    /**
     * Set the application language globally
     *
     * @param lang The language, for example: 'en'
     */
    Messages.prototype.currentLang = function (lang) {
        if (lang) {
            this.curLang = lang;
            this.curLocale = this.getCurrentLocale();
        }
        return this.curLang;
    };
    /**
     * Get current locale
     */
    Messages.prototype.getCurrentLocale = function () {
        var locale;
        switch (this.curLang) {
            case FRENCH:
                locale = 'fr-CA';
                break;
            case ENGLISH:
            default:
                locale = 'en-CA';
                break;
        }
        return locale;
    };
    Object.defineProperty(Messages.prototype, "currentLocale", {
        get: function () {
            return this.curLocale;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds the messages so that they can be resolved.
     *
     * @param lang The language, for example: 'en'
     * @param messages The messages
     */
    Messages.prototype.addMessages = function (lang, bundle) {
        var languageBundles = this.messages[lang];
        this.messages[lang] = Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"])({}, languageBundles), bundle);
    };
    /**
     * Allows to translate a key into the specified language.
     *
     * The resolution is made in this order:
     *
     * key.nb.modifier
     * key.p.modifier
     * key.nb
     * key.p
     * key.modifier
     * key
     */
    Messages.prototype.translate = function (key, params, nb, modifier, htmlEncodeParams, formatMode) {
        if (params === void 0) { params = []; }
        if (htmlEncodeParams === void 0) { htmlEncodeParams = true; }
        if (formatMode === void 0) { formatMode = this.formatMode; }
        if (!key) {
            throw new Error('The key is empty.');
        }
        var val = this.resolveKey(this.curLang, key, nb, modifier);
        if (htmlEncodeParams && params.length) {
            Object.keys(params).forEach(function (key) { params[key] = htmlEncode(params[key].toString()); });
        }
        if (formatMode === FormatMode.Sprintf || formatMode === FormatMode.Vsprintf) {
            params = Object.assign(this.specialCharacterDict, params);
        }
        val = this.format(val, params, formatMode);
        return val;
    };
    /**
     * format a string with depending on the option formatMode
     * @param {string} val the string to format
     * @param {any[]} params the values to insert in string
     */
    Messages.prototype.format = function (val, params, formatMode) {
        switch (formatMode) {
            case FormatMode.Vsprintf:
                return Object(sprintf_js__WEBPACK_IMPORTED_MODULE_1__["vsprintf"])(val, params);
            case FormatMode.Sprintf:
                return Object(sprintf_js__WEBPACK_IMPORTED_MODULE_1__["sprintf"])(val, params);
            default:
                return formatRegexp(val, params);
        }
    };
    Messages.prototype.resolveKey = function (lang, key, nb, modifier, encodeParams) {
        var val = undefined;
        if (nb !== undefined && modifier) {
            // key.nb.modifier
            val = this.findKey(lang, key + "." + nb + "." + modifier);
            if (val) {
                return val;
            }
            // key.p.modifier
            if (nb < -1 || nb > 1) {
                val = this.findKey(lang, key + ".p." + modifier);
                if (val) {
                    return val;
                }
            }
        }
        if (nb !== undefined) {
            // key.nb
            val = this.findKey(lang, key + "." + nb);
            if (val) {
                return val;
            }
            // key.p
            if (nb < -1 || nb > 1) {
                val = this.findKey(lang, key + ".p");
                if (val) {
                    return val;
                }
            }
        }
        if (modifier) {
            // key.modifier
            val = this.findKey(lang, key + "." + modifier);
            if (val) {
                return val;
            }
        }
        // key
        val = this.findKey(lang, key);
        if (val) {
            return val;
        }
        var error = "The key " + key + " does not exist. Current lang: " + this.curLang;
        if (this.options && this.options.debug === DebugMode.Throw) {
            throw new Error(error);
        }
        else {
            if (!this.options || this.options.debug === DebugMode.Warn) {
                vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$log.warn(error);
            }
            else {
                vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$log.debug(error);
            }
            return key;
        }
    };
    /**
     * Build the list of special characters that are automatically replaced to the desired pattern
     *
     * Example with '_' as PREFIXE and SUFIXE
     * NBSP => _NBSP_ : '\xOA'
     */
    Messages.prototype.initSpecialCharactersDict = function () {
        var _this = this;
        Object.keys(SpecialCharacter).forEach(function (key) {
            _this.specialCharacterDict["" + SPECIAL_CHARACTER_PREFIXE + key + SPECIAL_CHARACTER_SUFIXE] = String.fromCharCode(SpecialCharacter[key]);
        });
    };
    /**
     * Finds a key in the available messages or returns null.
     *
     * @param lang The language to use
     * @param key The key to find
     */
    Messages.prototype.findKey = function (lang, key) {
        var parts = key.split(':');
        if (parts.length !== 2) {
            var error = "The key " + key + " is invalid. The key needs to be in the format <bundle>:<id>";
            if (this.options && this.options.debug === DebugMode.Throw) {
                throw new Error(error);
            }
            else {
                if (!this.options || this.options.debug === DebugMode.Warn) {
                    vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$log.warn(error);
                }
                else {
                    vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$log.debug(error);
                }
                return undefined;
            }
        }
        var bundleName = parts[0];
        var id = parts[1];
        var langMsgs = this.messages[lang];
        var bundleMsgs = langMsgs && langMsgs[bundleName];
        return bundleMsgs && bundleMsgs[id];
    };
    return Messages;
}());

/**
 * Formats a value containing parameters.
 *
 * The format is 'This is a {0} containing {1}...'
 */
function formatRegexp(val, params) {
    return val.replace(FORMAT_REGEX, function (match) {
        // TODO: should use the regex variable notation instead of parsing the regex match
        var index = parseInt(match.substring(1, match.length - 1), 10);
        if (index >= params.length) {
            vue__WEBPACK_IMPORTED_MODULE_2___default.a.prototype.$log.warn("The parameter " + index + " doesn't exist while translating: '" + val + "'");
        }
        return params[index];
    });
}
/**
 * Encodes a value so that it can be inserted in an html string.
 * @param val The value to encode
 */
function htmlEncode(val) {
    return val
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
var MessagePlugin = {
    install: function (v, options) {
        v.prototype.$log.debug('$i18n', 'plugin.install');
        var msg = new Messages(options);
        (v.prototype).$i18n = msg;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (MessagePlugin);


/***/ }),

/***/ "sprintf-js":
/*!*****************************!*\
  !*** external "sprintf-js" ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("sprintf-js");

/***/ }),

/***/ "tslib":
/*!************************!*\
  !*** external "tslib" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),

/***/ "vue":
/*!**********************!*\
  !*** external "vue" ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ })

/******/ });
//# sourceMappingURL=fr.js.map